import { gsap } from "gsap";
import jQuery from "jquery";
import { PageHandler } from './PageHandler';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Utils } from "../misc/Utils";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export class AboutPageHandler extends PageHandler {
	constructor(id) {
		super(id);
	}

	ajax() {

	}

	events() {
		
	}

	transitions() {
		
	}

	init() {
		this.events();
	}

	destroy() {

	}
}
